// extracted by mini-css-extract-plugin
module.exports = {"modal":"EditActivityLog_modal__2TxI9"};